module.exports = __webpack_public_path__ + "static/media/Farma Pasa - Pustoparan - 02 Farma Pasa - Van sebe.800b1258.mp3";